/**
 * Save Data Operations - Hanterar Web Worker för att bearbeta och förbereda data för att spara districts
 * 
 * Använder closure för att hålla worker-instans
 */

// Closure state för worker-instans
let workerInstance = null;

/**
 * Skapa areas för att spara
 * @param {Array} selectedAreas - Array av GeoJSON features
 * @param {Object} turfPolygons - Object med turf polygons per type
 * @param {Function} onSave - Callback när save-data är klar: (saveData) => void
 * @param {Function} onReset - Callback för att resetta state: () => void
 */
export function createAreasForSave(selectedAreas, turfPolygons, onSave, onReset) {
    if (workerInstance) {
        workerInstance.terminate();
        workerInstance = null;
        if (onReset) {
            onReset();
        }
    }
    
    workerInstance = new Worker(new URL('./worker.js', import.meta.url));

    workerInstance.onmessage = (message) => {
        if (message.data.type === 'save') {
            if (onSave) {
                onSave(message.data);
            }
            terminate();
        }
    };
    
    workerInstance.postMessage({ 
        selectedAreas, 
        turfPolygons
    });
}

/**
 * Terminera worker-instansen
 */
export function terminate() {
    if (workerInstance) {
        workerInstance.terminate();
        workerInstance = null;
    }
}

/**
 * Kolla om worker är aktiv
 * @returns {boolean} True om worker är aktiv
 */
export function isActive() {
    return workerInstance !== null;
}
